// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__va6zW","title":"ClientCherryInfo_title__20uyL","itemText":"ClientCherryInfo_itemText__2_fwW"};